import { AiFillCloseCircle, AiFillCheckCircle } from 'react-icons/ai'

import { cn } from '@/lib/utils'

interface AlertProps {
  type?: 'error' | 'success'
  message: string
  className?: string
}

const alertVariants = {
  error: {
    background: 'bg-red-500',
    textColor: 'text-white',
    icon: <AiFillCloseCircle size={28} className="size-7" />
  },
  success: {
    background: 'bg-green-500',
    textColor: 'text-white',
    icon: <AiFillCheckCircle size={28} className="size-7" />
  }
}

export const Alert = ({ type = 'success', message, className }: AlertProps) => {
  const { background, textColor, icon } = alertVariants[type]

  return (
    <div
      className={cn('flex items-center gap-1.5 lg:gap-2 p-3 text-sm lg:text-base rounded', background, textColor, className)}
    >
      {icon}
      <p>{message}</p>
    </div>
  )
}
